import { useMemo } from "react";
import { createApiClient, type ApiClient } from "../api/client.ts";

export function useApiClient(): ApiClient {
  return useMemo(() => createApiClient({
    apiBase: import.meta.env.VITE_API_BASE_URL,
    deviceToken: import.meta.env.VITE_DEVICE_TOKEN,
    deviceId: import.meta.env.VITE_DEVICE_ID,
  }), []);
}
